import React, { FC } from 'react';
import classNames from 'classnames';

import { NumberSignEnum } from '../../../../lib/enums';
import { TopGainerAndLoserData } from '../../../../lib/models/fundamental/types';
import TradePriceCache from '../../../../lib/store-util/TradePriceCache';
import { getPriceColorByDirection } from '../../../../lib/util/ChartingHelpers';
import { formatCurrency } from '../../../../lib/util/DataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import styles from '../../EpicMovers.module.scss';

type Props = { isReduction: boolean, item: TopGainerAndLoserData, isLoading: boolean }

const PriceAndChange: FC<Props> = (props: Props): JSX.Element => {
  const { item, isReduction, isLoading } = props;
  if (!item.price) {
    return <>{INVALID_VALUE}</>;
  }

  const { symbol } = item;
  const { currentPrice, changePercent, direction } = TradePriceCache.use(symbol, 'SymbolTradeInfoCard');
  const color = getPriceColorByDirection(direction);

  return (
    <div className={styles.priceAndChangeContainer}>
      {isLoading ? (
        <>
          <div className={classNames(styles.loadingComponent, styles.loadingComponentMargin)} style={{ width: 40 }} />
          <div className={styles.loadingComponent} style={{ width: 50 }} />
        </>
      ) : (
        <>
          <span className={styles.priceAndChange}>
            {formatCurrency(currentPrice ?? item.price)}
          </span>
          {
            currentPrice && (
              <span style={{ color }}>
                (
                {direction}
                {changePercent}
                )
              </span>
            )
          }
          {
            !currentPrice && (
              <span className={isReduction ? styles.negative : styles.positive}>
                (
                {!isReduction && NumberSignEnum.Positive}
                {item.changePercentage}
                )
              </span>
            )
          }
        </>
      )}
    </div>
  );
};

export default PriceAndChange;
